import { render, staticRenderFns } from "./FeaturedMagazineSection.vue?vue&type=template&id=80b26746&scoped=true&"
import script from "./FeaturedMagazineSection.vue?vue&type=script&lang=js&"
export * from "./FeaturedMagazineSection.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMagazineSection.vue?vue&type=style&index=0&id=80b26746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b26746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
